<template>
    <div class="row justify-content-sm-center">
        <div class="col-sm-6">
            <form class="shaded" @submit.prevent.stop="processForm" novalidate>

                <div class="form-group" :class="{ error: $v.form.name.$error }">
                    <label class="full">
                        Your name
                        <input v-model="form.name" type="text" placeholder="" @input="$v.form.name.$touch">
                    </label>

                    <div v-if="$v.form.name.$error" class="messages">
                        <span v-if="!$v.form.name.required">First and last name are required.</span>
                        <span v-if="!$v.form.name.minLength">Your first and last name must have at least 4 characters.</span>
                    </div>
                </div>

                <div class="form-group" :class="{ error: $v.form.email.$error }">
                    <label class="full">
                        Email
                        <input type="email" v-model.trim.lazy="form.email" placeholder="Your email" @blur="$v.form.email.$touch">
                    </label>

                    <div v-if="$v.form.email.$error" class="messages">
                        <span v-if="!$v.form.email.required">Email is required.</span>
                        <span v-if="!$v.form.email.email">Must be a valid email.</span>
                        <span v-if="!$v.form.email.isUnique">This email is already in use.</span>
                    </div>
                </div>

                <div class="form-group" :class="{ error: $v.form.password.$error }">
                    <label class="full">
                        Password
                        <input type="password" v-model.trim="form.password" placeholder="Your password" @input="$v.form.password.$touch">
                    </label>

                    <div v-if="$v.form.password.$error" class="messages">
                        <span v-if="!$v.form.password.required">Please type a password.</span>
                        <span v-if="!$v.form.password.minLength">Minimum length of 4 characters.</span>
                    </div>
                </div>

                <div class="fs-smaller mt-2">
                    <checkbox class="d-inline" name="terms" value="true" v-model="form.hasAcceptTermsConditions"></checkbox>
                    I accept the

                    <span class="darker underlined pointer" @click="openConditions">Terms of Service and Privacy Policy</span>
                </div>

                <input type="submit" class="btn blue widest full" value="Sign up free" :disabled="$v.$invalid">

                <!-- <div class="fs-smaller">
                    By clicking "Sign up free" you accept our
                    <router-link :to="{ name: 'basic.tos' }" class="darker underlined">Terms of Service</router-link> and <router-link :to="{ name: 'basic.privacy' }" class="darker underlined">Privacy Policy</router-link>
                </div> -->
            </form>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { required, email, minLength } from 'vuelidate/lib/validators'
    import Modal from '../../../tools/modal/Modal'

    export default {
        created: function() {
            this.eventHub.$emit('sidebar', 'signup');
            this.eventHub.$emit('topLink', 'login');

            // If we com from 'back button', fill the form.
            // Else start from scratch

            if (this.accountSetup.email !== undefined && this.accountSetup.email) {
                this.form = this.accountSetup;
            }
            else {
                this.resetAccountSetup('agent'); //commented to prevent wiping when coming back on signup process
                this.form = this.accountSetup;
            }
        },
        data: function() {
            return {
                step: 1,
                form: {
                    email: '',
                    password: '',
                    hasAcceptTermsConditions: false
                },
            }
        },
        validations: {
            form: {
                name: {
                    required,
                    minLength: minLength(4)
                },
                email: {
                    required,
                    email,
                    isUnique () {
                        return this.isUniqueEmail;
                    }
                },
                password: {
                    required,
                    minLength: minLength(6)
                },
                hasAcceptTermsConditions: {
                    required
                }
            },
        },
        mounted: function() {
        },
        computed: {
            ...mapGetters([
                'accountSetup'
            ]),
        },
        asyncComputed: {
            isUniqueEmail: {
                get () {
                    let email = this.form.email;

                    if (this.form.email && email != '') {

                        axios.get(axios.authURL + 'auth/IsEmailFree', {
                            params: {
                                email: email
                            }
                        }).then(response => {
                            if (response && response.status === 200) {
                                return response.data.isSuccessStatusCode;
                            }
                        }).catch(error => {
                            console.log(error.response.data.message);
                        })

                    }

                    return true;
                },
                default: false
            }
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'openModal'
            ]),
            processForm: function() {
                if (!this.$v.form.$error) {
                    this.form.step = this.step + 1;

                    // Update account setup data

                    this.updateAccountSetup(this.form);

                    // Move on to step 2

                    this.$router.push({ name: 'auth.signup.agent.create' });
                }
            },
            openConditions: function() {
                // this.openModal('TosConditions');
                window.open('https://help.pluralo.com/agent.html', '_blank');
            },
        },
        components: {
            vSelect: extendedVSelect,
            Modal,
        }
    }
</script>



// WEBPACK FOOTER //
// Step1.vue?07a59a80